

// 新协议
function kkmhhybrid_set_screen_display (opt) {
  hybrid({
    hybridParam: {
      schema: "kkmhhybrid",
      tagname: "set_screen_display",
    },
    param: {
      type: opt.type || 0,
      full_screen: opt.full_screen || 0,
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}


// 旧协议
function kkhybrid_header (opt) {
  hybrid({
    hybridParam: {
      schema: "kkhybrid",
      tagname: "header",
    },
    param: {
      config: 'screen',
      display: opt.type === 0 ? 1 : 2,
      fullScreen: opt.full_screen === 0 ? 'hide' : 'show',
      data: {}
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}


/**
 * 控制头部<br>
 * kkmhhybrid:// set_screen_display，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=81821998}<br>
 * kkhybrid:// header，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=43387146}<br>
 * @param {Object} opt 参数对象
 * @param {Number} opt.type 区分竖屏&横屏, 0 -> 竖屏 1 -> 横屏 【默认0】
 * @param {String} opt.full_screen 是否为全屏, 0 -> 非全全屏模式 1 →全屏模式 【默认0】
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */
function set_screen_display (opt, criticalAppVersion) {
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion);
  if(allow) {
    // 调用新协议
    kkmhhybrid_set_screen_display(opt);
  } else {
    // 调用旧协议
    kkhybrid_header(opt);
  }
}

export default set_screen_display;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/set_screen_display/index.js